import React from 'react';

import {useTranslation} from 'react-i18next';
import {IconButtonList} from './IconButtonList';
import {Sport} from "../../models/api/codegen/code";
import clsx from "clsx";

export const SportLogoFilterSelector: React.FC<{
    sports: Record<number, Sport>,
    callback: (sportId: number | undefined) => void,
    sportId?: number,
    page: 'Live' | 'Result'
}> = ({sports, callback, sportId, page}) => {
    const {t} = useTranslation();
    const [show, setShow] = React.useState(true);

    React.useEffect(() => {
        sportId && setShow(false)
    }, [sportId]);

    const handleClick = () => {
        callback(undefined);
        setShow(true);
    };

    const handleShowOff = () => {
        setShow(false);
    };


    return (
        <div className="grid grid-cols-[max-content,1fr] pb-[8px] max-tablet:mx-[4px]">
            <div
                className={clsx(
                    "rounded-[8px] normal-case tablet:font-normal h-[40px] tablet:h-[56px] w-[120px] flex justify-center items-center text-[12px] tablet:text-[16px] cursor-pointer",
                    show ? "bg-[#171A1E]" : "bg-[#21262B]")}
                onClick={handleClick}
            >
                <span className={show ? "text-[#FFDB4D]" : "text-[#ABABAB]"}>
                {t(`live.sportLogoFilterSelector.all${page}Button`)}
                </span>
            </div>
            <IconButtonList sportId={sportId} sports={sports} callback={callback} handleShowOff={handleShowOff}/>
        </div>
    );
};
